<template>
  <div
    class="items readio-box"
    :name="selectData.elementCode"
    :data-path="selectData.elementPath"
    :class="[radio == 1?'active':'']"
  >
    <div class="items-wrap" @click="changeReadio">
        <van-icon name="circle" class="check-ico" v-if="radio!=1"/>
        <van-icon name="passed" class="check-ico" v-if="radio == 1"/>
        <span>{{selectData.elementDescribe}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectData: {
      type: Object,
    },
  },
  data() {
    return {
      radio:"2",
    };
  },
  mounted() {
    if (this.selectData.elementValue) {
      this.radio = this.selectData.elementValue;
    }
  },
  methods: {
    changeReadio() {
        if(this.radio == 1){
            this.radio = "2";
        }else{
            this.radio = "1";
        }
      this.selectData.elementValue = this.radio;
      this.$emit("selected", {
        type: -1,
        item: this.selectData,
        value: this.radio,
      });
    },
  },
  watch: {
    selectData(newVal) {
      this.radio = newVal.elementValue;
    }
  },
};
</script>

<style lang="scss" scoped>
.van-uploader {
  padding-top: 15px;
}
.verify-box {
  padding-left: 230px;
  padding-bottom: 5px;
  .verify-title {
    font-size: 30px;
    color: #333;
  }
  .verify-li {
    font-size: 28px;
    color: #666;
    line-height: 1.4;
    padding: 3px 0;
    border-bottom: 1px dashed #ececec;
    word-break: break-all;
  }
}
.img-box {
  .lables {
    width: 40%;
  }
  .from-right {
    width: 58%;
  }
}
</style>